<template>
	<div class="largemarket" v-loading="loadshow">
		<div class="bullehead FlexBetween">
			<div class="head_left FlexRow">
				<div class="head_title">
					数据大盘
				</div>
				<div class="Quicka FlexRow">
					<el-dropdown @command="handleCommand" trigger="click">
						<span class="spanlink">
							子报表快捷入口<i class="el-icon-arrow-down"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="1">分享内容报表</el-dropdown-item>
							<el-dropdown-item command="2">转发内容报表</el-dropdown-item>
							<el-dropdown-item command="3">浏览记录报表</el-dropdown-item>
							<el-dropdown-item command="4">成员获客报表</el-dropdown-item>

						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
			<div class="head_right FlexRow">
				<el-select ref="groupSrc" class="input_style2" v-model="group_src" placeholder="部门筛选" clearable>
					<el-option value="" style="height: auto">
						<el-tree class="filter-tree" :data="grouplist" :props="defaultProps" default-expand-all
							:filter-node-method="filterNode" :expand-on-click-node="false" @node-click="clickGroup"
							ref="tree">
						</el-tree>
					</el-option>
				</el-select>

				<el-select clearable :disabled="memb_isabled" class="input_style" v-model="member_id"
					placeholder="成员筛选">
					<el-option :label="item.name" :value="item.member_id"
						v-for="(item, index) in member_list"></el-option>
				</el-select>

				<timesel @transTime="getranTime"></timesel>

				<el-button class="export" @click="fn_querytime">查询</el-button>
			</div>
		</div>


		<div class="dataplays_content FlexBetween">
			<div class="dataplays_box FlexBetween" v-for="(item1, index1) in contrastlist">
				<template v-if="item1.list">
					<div class="dataplays_item " v-for="(item2, index2) in item1.list">
						<div class="num">
							{{item2.num || 0}}
						</div>
						<div class="tit">
							{{item2.title || ''}}
						</div>

						<div class="contrast">
							<div class="RingRatio Flexalign">
								<span>
									环比
								</span>
								<div class="Percents Flexalign style1" v-if="item2.Ringratio < 0">
									<i class="el-icon-caret-bottom"></i>
									{{Math.abs(item2.Ringratio)}} %
								</div>
								<div class="Percents Flexalign style1" v-else-if="item2.Ringratio == 0">
									<i>
										--
									</i>
									{{item2.Ringratio}}%
								</div>
								<div class="Percents Flexalign style2" v-else>
									<i class="el-icon-caret-top"></i>
									{{item2.Ringratio}} %
								</div>
							</div>
							<div class="RingRatio Flexalign">
								<span>
									同比
								</span>

								<div class="Percents Flexalign style1" v-if="item2.Tongratio < 0">
									<i class="el-icon-caret-bottom"></i>
									{{Math.abs(item2.Tongratio)}} %
								</div>
								<div class="Percents Flexalign style1" v-else-if="item2.Tongratio == 0">
									<i>
										--
									</i>
									{{item2.Tongratio}}%
								</div>
								<div class="Percents Flexalign style2" v-else>
									<i class="el-icon-caret-top"></i>
									{{item2.Tongratio}} %
								</div>


							</div>
						</div>
					</div>
				</template>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		get_member_detailed_list,
		get_admin_department,
		get_customer_kanban_market,
		getThisYear,
		fn_overload,
		getSecondTime,
	} from "../js/billet.js"

	import {
		handlereq,
		alertMess,
		try_catch,
	} from 'network/kh_public'



	import timesel from "./timesel.vue"
	export default {
		name: 'largemarket',
		components: {
			timesel,
		},

		watch: {
			group_src() {
				if (this.group_src == '') {
					this.member_list = []
					this.memb_isabled = true
					this.currentgroup_id = ''
					this.member_id = ''
					this.fn_querytime()
				} else {
					this.member_id = ''
					this.fn_membelist()
				}
			},
			member_id() {
				this.$forceUpdate()
				this.fn_querytime()
			},
		},
		methods: {
			getdatalist() {
				this.loadshow = true
				let data = {
					member_id: this.member_id, //	否	int	成员id
					search_time: this.tranTime ? this.tranTime : getThisYear(),
				}
				get_customer_kanban_market(data).then(res => {
					if (!res) return
					let obj = res.result
					if (obj) {
						this.market_data = obj
						this.headledata(obj)
					}
				})
			},
			headledata(obj) {
				for (let i = 0; i < this.contrastlist.length; i++) {
					let curobj = this.contrastlist[i].list
					for (let j = 0; j < curobj.length; j++) {
						let lisobj = curobj[j]
						if (i == 0) {
							if (j == 0) {
								lisobj.num = fn_overload(obj.share_content)
								lisobj.Ringratio = obj.lrr_share_content
								lisobj.Tongratio = obj.yoy_share_content
							} else if (j == 1) {
								lisobj.num = fn_overload(obj.visit)
								lisobj.Ringratio = obj.lrr_visit
								lisobj.Tongratio = obj.yoy_visit
							} else if (j == 2) {
								lisobj.num = getSecondTime(obj.visit_time)
								lisobj.Ringratio = obj.lrr_visit_time
								lisobj.Tongratio = obj.yoy_visit_time
							}
						} else if (i == 1) {
							if (j == 0) {
								lisobj.num = fn_overload(obj.cuepool)
								lisobj.Ringratio = obj.lrr_cuepool
								lisobj.Tongratio = obj.yoy_cuepool
							} else if (j == 1) {
								lisobj.num = fn_overload(obj.customer)
								lisobj.Ringratio = obj.lrr_customer
								lisobj.Tongratio = obj.yoy_customer
							} else if (j == 2) {
								lisobj.num = fn_overload(obj.forward)
								lisobj.Ringratio = obj.lrr_forward
								lisobj.Tongratio = obj.yoy_forward
							}
						}
					}
				}
				this.loadshow = false
			},
			handleCommand(index) {
				let urlArr = [
					'/data/bulletinboard/sharepag',
					'/data/bulletinboard/retransmission',
					'/data/bulletinboard/browsepag',
					'/data/bulletinboard/membrpag',
				]
				this.$router.push(urlArr[index - 1])
			},
			fn_querytime() {
				let res = {
					member_id: this.member_id,
					time: this.tranTime ? this.tranTime : getThisYear(),
				}
				this.getdatalist()
				this.$emit('retquery', res)
			},
			getranTime(e) {
				let {
					result
				} = e
				this.tranTime = result || ''
				this.fn_querytime()
			},
			// 添加分组 -> 点击分组
			clickGroup(data, node, item) {
				let thisFile = data.name
				this.currentgroup_id = data.department_id
				let nameList = []
				function findParent(node) {
					for (let folder in node) {
						if (folder === 'data') {
							nameList.push(node[folder].name)
							if (typeof node[folder] == 'object') {
								findParent(node.parent)
							}
						}
					}
				}
				findParent(node)
				nameList.pop()
				let src = "";
				for (let i = nameList.length - 1; i >= 0; i--) {
					src += nameList[i] + "/"
				}
				this.group_src = src
				this.$refs.groupSrc.blur()
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.name.indexOf(value) !== -1;
			},
			// 获取部门
			fn_department() {
				get_admin_department().then(res => {
					if (!res) return
					let obj = res.result
					let newArr = []
					if (obj.length) {
						if (obj[0].department_id) {
							newArr = obj
						}
					} else {
						if (obj.department_id) {
							newArr.push(obj)
						}
					}
					this.grouplist = newArr
				})
			},
			// 获取成员
			fn_membelist() {
				let data = {
					pagesize: 999, //  	是	int	页码
				}
				if (this.currentgroup_id) { //  否	int	部门id
					data.department_id = this.currentgroup_id
				}
				get_member_detailed_list(data).then(res => {
					if (!res) return
					let obj = res.result.data
					this.member_list = obj
					this.memb_isabled = false
				})
			},
		},
		created() {
			this.fn_department()
			this.getdatalist()
		},
		data() {
			return {
				loadshow: true,

				market_data: '',

				tranTime: '',

				Quick_val: '',

				grouplist: [],
				currentgroup_id: '',
				groupname: '',
				group_src: '',

				defaultProps: {
					children: 'son',
					label: 'name'
				},

				member_id: '',
				member_list: [],
				memb_isabled: true,

				contrastlist: [{
						list: [{
								title: '分享次数',
								num: 0,
								Ringratio: '',
								Tongratio: '',
							},
							{
								title: '浏览次数',
								num: 0,
								Ringratio: '',
								Tongratio: '',
							},
							{
								title: '访问时长',
								num: 0,
								Ringratio: '',
								Tongratio: '',
							},
						],
					},
					{
						list: [{
								title: '新增线索',
								num: 0,
								Ringratio: '',
								Tongratio: '',
							},
							{
								title: '意向客户',
								num: 0,
								Ringratio: '',
								Tongratio: '',
							},
							{
								title: '裂变转发',
								num: 0,
								Ringratio: '',
								Tongratio: '',
							},
						],
					},

				],

			}
		},


	}
</script>

<style lang="scss" scoped>
	@import "../css/billet.scss";
	.largemarket {
		background-color: #fff;
	}
	.dataplays_content {
		width: 100%;

		.dataplays_box {
			flex: 1;
			padding: 30px 0;
			// border: solid 1px red;
			position: relative;
		}

		.dataplays_box::after {
			content: '';
			display: block;
			border-right: solid 1px rgba(243, 243, 243, 1);
			height: 113.53px;
			position: absolute;
			right: 0;
		}

		.dataplays_box:last-of-type::after {
			display: none;
		}

	}

	.dataplays_item {

		flex: 1;
		padding-left: 60px;

		// border:solid 1px red;
		.tit {
			white-space: nowrap;
			font-size: 13px;
			color: rgba(96, 98, 102, 1);
			margin: 15px 0 20px 0;
		}

		.num {
			white-space: nowrap;

			font-size: 28px;
			font-weight: 500;
			color: rgba(43, 117, 235, 1);
		}

		.contrast {
			.RingRatio {
				margin-bottom: 5px;
				white-space: nowrap;

				>span {
					font-size: 12px;
					color: rgba(153, 153, 153, 1);
				}

				.Percents.style1 {
					color: rgba(30, 158, 49, 1);
				}

				.Percents.style2 {
					color: rgba(249, 95, 94, 1);
				}

				.Percents {

					font-size: 12px;

					i {
						margin: 0 6px;
					}
				}
			}
		}
	}
</style>